import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryFieldwork} from "@/service/fieldwork.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Stack, Grid} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime, getRealId, getSellerNames} from "@/helper/method";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";

interface ViewFieldworkProps {
    mode: ModeType
}

export const ViewFieldwork: FC<ViewFieldworkProps> = ({mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const id: number = getRealId(mode, drawerId, dialogId);
    const {data: fieldworkData, isLoading: fieldworkLoading} = useQueryFieldwork({id}, isNumber(id))
    const fieldwork = fieldworkData?.data
    return <> <ResultWrapper isLoading={fieldworkLoading} isEmpty={isEmpty(fieldwork)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'客户名称'} content={fieldwork?.customerName}/>
                <GridItem title={'业务人员'} content={getSellerNames(fieldwork?.creator, fieldwork?.seller)}/>
                <GridItem title={'联系人'} content={fieldwork?.contact}/>
                <GridItem title={'联系电话'} content={fieldwork?.mobile}/>
                <GridItem title={'随行人员'} content={fieldwork?.followers}/>
                <GridItem title={'出行时间'} content={`${formatTime("D", fieldwork?.startTime)}至${formatTime("D", fieldwork?.endTime)}`}/>
                <GridItem title={'业务内容'} minHeight={"48px"} size={12} content={fieldwork?.business}/>
                <GridItem title={'更新时间'} content={formatTime("D", fieldwork?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime("D", fieldwork?.createdAt)}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}